export default "__VITE_ASSET__79ae74dc__"